// 组件对象，大写
import radioRemote from './radioRemote.vue'
export default radioRemote
